import { PartnerDecision, PartnerDecisionCause, PartnerDecisionReason } from "@bbj-types/socialApply/enum";

export const PARTNER_DECISION_CAUSE: Record<PartnerDecisionCause, string> = {
  [PartnerDecisionCause.NOT_IN_RSA_PLAN]: "Déclare ne plus être dans le dispositif RSA",
  [PartnerDecisionCause.HAS_JOB]: "Déclare être en emploi maintenant",
  [PartnerDecisionCause.OUTSIDE_TERRITORY]: "Déclare être hors territoire",
  [PartnerDecisionCause.HAS_MOVED]: "N'habite plus à l'adresse indiquée",
  [PartnerDecisionCause.NO_ANSWER]: "N'a pas répondu aux 3 convocations",
  [PartnerDecisionCause.BENEFICIARY_REFUSAL]: "Refus de l'allocataire",
};

export const PARTNER_REASONS: Record<PartnerDecisionReason, string> = {
  [PartnerDecisionReason.EXCUSED_ABSENCE]: "Absence excusée",
  [PartnerDecisionReason.UNEXCUSED_ABSENCE]: "Absence non excusée",
};

export const PARTNER_DECISION: Record<PartnerDecision, string> = {
  [PartnerDecision.INTEGRATED]: "Intègre la prestation",
  [PartnerDecision.NOT_INTEGRATED]: "N'a pas intégré la prestation",
};
